import React from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes, { arrayOf } from 'prop-types';
import clsx from 'clsx';
import { Box, Typography, InputLabel } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';

import useStyles from './useStyles';

const Select = props => {
  const {
    onChange,
    placeholder,
    options,
    defaultOptionValue,
    className,
    fullWidth,
    error,
    helperText,
    formControlClassName,
    ...rest
  } = props;
  const classes = useStyles();

  const shouldShowLabel = isBlank(defaultOptionValue);

  return (
    <Box className={clsx(classes.paper, className)}>
      <FormControl
        fullWidth={fullWidth}
        error={error}
        variant="outlined"
        className={clsx(classes.root, formControlClassName)}
      >
        {shouldShowLabel && <InputLabel>{placeholder}</InputLabel>}
        <MuiSelect
          error={error}
          value={defaultOptionValue}
          onChange={onChange}
          classes={{ icon: classes.icon }}
          {...rest}
        >
          {options.map((option, index) => {
            const key = `${option.value}${index}`;
            return (
              <MenuItem key={key} value={option.value} className={classes.item}>
                {option.label}
              </MenuItem>
            );
          })}
        </MuiSelect>
      </FormControl>
      {error && (
        <Typography variant="subtitle1" className={classes.errorText}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: arrayOf(PropTypes.shape()).isRequired,
  defaultOptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  formControlClassName: PropTypes.string,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

Select.defaultProps = {
  className: '',
  formControlClassName: '',
  fullWidth: false,
  defaultOptionValue: '',
  error: false,
  helperText: '',
};

export default Select;



// WEBPACK FOOTER //
// ./src/sharedComponents/Select/Select.js